import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchChangePassword } from '../api';
import {
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailed,
} from '../reducer/changePasswordSlice';

interface ChangePasswordRequestAction {
  type: typeof changePasswordRequest.type;
  payload: {
    accountId: string;
    customerId: string;
    username: string;
    oldPassword: string;
    currentPassword: string;
    newPassword: string;
    verifyPassword: string;
    recaptchaToken?:string
  };
}

export function* changePasswordSaga(
  action: ChangePasswordRequestAction
): Generator<any, void, unknown> {
  try {
    const {
      accountId,
      customerId,
      username,
      oldPassword,
      newPassword,
      verifyPassword,
      recaptchaToken,
    } = action.payload;

    // Call the API to perform the password change
    const changePasswordResponse: any = yield call(
      fetchChangePassword,
      'change_password',
      accountId,
      customerId,
      username,
      oldPassword,
      newPassword,
      verifyPassword,
      recaptchaToken
    );
    if (changePasswordResponse?.statusCode === '200') {
      yield put(changePasswordSuccess(changePasswordResponse));
    } else {
      yield put(changePasswordFailed(changePasswordResponse));
    }
  } catch (error: any) {
    yield put(changePasswordFailed(error || 'Failed to change password'));
  }
}

export function* watchChangePasswordSaga() {
  yield takeLatest(changePasswordRequest.type, changePasswordSaga);
}
